// extracted by css-extract-rspack-plugin
export default {"cls1":"step_two-cls1_KEB","cls2":"step_two-cls2_1aL step_two-cls1_KEB"};